import WeeklyTask from '@/locales/module/WeeklyTaskI18n';
import BadgeWall from './module/BadgeWallI18n';
import ChipHowToPlay from './module/ChipHowToPlayI18n';
import GainEntryExplain from './module/GainEntryExplainI18n';
import GuideRole from './module/GuideRoleI18n';
import SlotMachine from './module/SlotMachineI18n';
import YuliAttributes from './module/YuliAttributesI18n';
import YuliHowToPlay from './module/YuliHowToPlayI18n';
import app_home_center from './module/app_home_center';
import app_profile_center from "./module/app_profile_center";

/**当前主文件 - 版本号 */
export const version = 10;

/**周任务 - 语言环境 */
export const WeeklyTaskI18n = WeeklyTask;

/**徽章墙 - 语言环境 */
export const BadgeWallI18n = BadgeWall;

/**芯片玩法说明 - 语言环境 */
export const ChipHowToPlayI18n = ChipHowToPlay;

/**yuli属性说明 - 语言环境 */
export const GainEntryExplainI18n = GainEntryExplain;

/**角色技能说明 - 语言环境 */
export const GuideRoleI18n = GuideRole;

/**老虎机 - 语言环境 */
export const SlotMachineI18n = SlotMachine;

/**芯片词条属性说明 - 语言环境 */
export const YuliAttributesI18n = YuliAttributes;

/**净化地脉玩法说明 - 语言环境 */
export const YuliHowToPlayI18n = YuliHowToPlay;

/**app home_center */
export const AppHomeCenter = app_home_center;

/**app profile_center */
export const AppProfileCenter = app_profile_center;
